"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateThread = exports.translateReply = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var translateThread = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
    var res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.post('/onDemandAI/translateThread', data);

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data.translation);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function translateThread(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.translateThread = translateThread;

var translateReply = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(data) {
    var res;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/onDemandAI/translate', data);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function translateReply(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.translateReply = translateReply;